import { Globe, Lock } from "lucide-react";

const VISIBILITY_STYLES = {
  public: {
    classes: "bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-300 dark:border-sky-700",
    icon: Globe,
  },
  private: {
    classes: "bg-slate-500/10 text-slate-600 dark:text-slate-400 border-slate-300 dark:border-slate-700",
    icon: Lock,
  },
} as const;

export function VisibilityBadge({ visibility }: { visibility: string | null | undefined }) {
  const key = visibility === "public" ? "public" : "private";
  const { classes, icon: Icon } = VISIBILITY_STYLES[key];
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${classes}`}>
      <Icon className="h-3 w-3" />
      {visibility ?? key}
    </span>
  );
}
